module.exports = __webpack_public_path__ + "static/media/birthday-party-grid-2.8bdce55b.jpg";